import { render, staticRenderFns } from "./ConfirmOrderAdmin.vue?vue&type=template&id=66816fd4&scoped=true"
import script from "./ConfirmOrderAdmin.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderAdmin.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOrderAdmin.vue?vue&type=style&index=0&id=66816fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66816fd4",
  null
  
)

export default component.exports